import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useAvatarColorList } from '@/modules/avatar/color/model/list';
import { useAvatarLayerList } from '@/modules/avatar/layer/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarImageAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify } = useCrudActions();

    const { colorOption, fetchList: fetchColors } = useAvatarColorList();
    const { layerOption, fetchList: fetchLayers } = useAvatarLayerList();

    const model = reactive({
        itemId: route.params.itemId,
        itemName: null,
        categoryId: null,
        colorId: null,
        layerId: null,
        isDefault: false,
        imageFile: null
    });

    const loadInitialData = async () => {
        await Promise.all([fetchColors(), fetchLayers()]);
    };

    const fetch = executeAction({
        request: () => avatarService.item.get(model.itemId),
        onSuccess: ({ data }) => {
            model.itemId = data.id;
            model.itemName = data.name;
            model.categoryId = data.categoryId;
            model.colorId = colorOption.value?.[0]?.value;
            model.layerId = layerOption.value?.[0]?.value;
        },
        onError: () => {
            router.push({ name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: model.itemId } });
        }
    });

    const create = excuteAndNotify({
        request: () =>
            avatarService.image.add(model.itemId, model.colorId, model.layerId, model.isDefault, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: model.itemId } })
    });

    onMounted(async () => {
        await loadInitialData();
        await fetch();
    });

    return { model, colorOption, layerOption, fetch, create };
}
